import React, { Component } from 'react';
import { Link } from 'react-router';
import { Container } from 'reactstrap';

const TABS = [
  { id: 'overview',                 label: 'Overview',                 path: '/dashboard' },
  { id: 'periodical_master',        label: 'Periodical Master',        path: '/periodical_master' },
  { id: 'frequency_master',         label: 'Frequency Master',         path: '/accurence_master' },
  { id: 'allocation',               label: 'Allocation',               path: '/periodical_configuration' },
  { id: 'scheduling',               label: 'Scheduling',               path: '/periodical_scheduling' },
  { id: 'periodical_report',        label: 'Periodical Report',        path: '/reports' },
  // { id: 'periodical_status_report', label: 'Periodical Status Report', path: '/periodical_status_report' },
  { id: 'status_view',              label: 'Status View',              path: '/status_view' },
];

class WorkScheduler extends Component {
  render() {
    return (
      <Container fluid={true}>
        <div className="ws-content">
          {this.props.children}
        </div>
      </Container>
    );
  }
}

export default WorkScheduler;



// WEBPACK FOOTER //
// ./src/shared/containers/WorkScheduler/index.js